import { render, staticRenderFns } from "./GlobalAlert.vue?vue&type=template&id=7e4a41da&"
import script from "./GlobalAlert.vue?vue&type=script&lang=js&"
export * from "./GlobalAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports